import { notification } from 'ant-design-vue'

export const notice = (type, string) => {
  notification[type]({
    message: string,
  })
}
